import { FunctionalComponent } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@insided/deprecated-preact-components/modal'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'
import Button from '@insided/control/uikit/Button'

interface ConfirmationModalProps {
  isOpen: boolean
  onClose: (event: MouseEvent) => void
  customPageTitle?: string
  error?: string
  isLoading: boolean
  onDelete: (event: MouseEvent) => void
}

const DeleteConfirmationModal: FunctionalComponent<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  customPageTitle,
  error,
  isLoading,
  onDelete
}) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader title='Delete custom page' onClose={onClose} />
      <ModalBody>
        <p>
          Are you sure that you want to delete <b>{customPageTitle}</b>?
        </p>
        <p>
          <strong>This action can’t be reverted.</strong>
        </p>
        {error && (
          <div className='error-message-container'>
            <Icon width={20} height={20} customClass='icon-warning' icon='warning' />
            <div className='error-message'>{error}</div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button isLoading={isLoading} title='Delete' variant='brand' size='medium' onClick={onDelete} />
        <Button title='Cancel' size='medium' onClick={onClose} />
      </ModalFooter>
    </Modal>
  )
}

export default DeleteConfirmationModal
